import { createContext } from 'react'

type SamlRestrictedCompany = {
  id: string
  companyName: string
}

export type SamlSessionContextValue = {
  samlRestrictedCompanies: SamlRestrictedCompany[]
  hasActiveSamlSession: (idCompany: string) => boolean
}

export const SamlSessionContext = createContext<SamlSessionContextValue>({
  samlRestrictedCompanies: [],
  hasActiveSamlSession: () => false,
})
